import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Checkbox} from "primereact/checkbox";
import {InputText} from "primereact/inputtext";

import "../Client/landing.css";

import logo from "../../images/logo.webp";
import {post} from "../../common/requester";
import appStore from "../../storage/AppStore";
import {HtmlDiv} from "../../common/utils";

export default function SignAgreement() {
    const navigate = useNavigate();

    const [agreement, setAgreement] = useState(null);
    const [fullName, setFullName] = useState("");
    const [accepted, setAccepted] = useState(false);

    useEffect(() => {
        document.body.classList.add("landing-page-body");
        document.documentElement.classList.add("landing-page-html");

        loadAgreement();

        return () => {
            document.body.classList.remove("landing-page-body");
            document.documentElement.classList.remove("landing-page-html");
        };
    }, []);

    const loadAgreement = async () => {
        const response = await post("agreements/required", {});

        const item = response.agreement || response.data;
        if (!item) {
            sessionStorage.removeItem("agreement_required");
            sessionStorage.removeItem("agreement_return_url");
            window.location.replace("/");
            return;
        }

        setAgreement(item);

        if (item?.full_name) {
            setFullName(item.full_name);
        }
    };

    const acceptAgreement = async () => {
        if (!agreement || !accepted || !fullName.trim()) {
            return;
        }

        const response = await post("agreements/accept", {
            agreement_id: agreement.id,
            version: agreement.version,
            full_name: fullName.trim(),
            company_user_id: agreement.company_user_id
        });

        if (response.result === 0) {
            sessionStorage.removeItem("agreement_required");
            sessionStorage.removeItem("agreement_return_url");
            window.location.replace("/");
        }
    };

    return (
        <div className="lnd agreement-page">

            {/* HEADER */}
            <header className="lnd-nav">
                <div className="lnd-container lnd-nav__inner">

                    <div className="lnd-brand">
                        <img
                            src={logo}
                            className="lnd-logo"
                            alt="Club #1"
                        />

                        <div className="lnd-brand__text">
                            <div className="lnd-brand__name">
                                Club #1
                            </div>
                        </div>
                    </div>

                </div>
            </header>


            {/* AGREEMENT */}
            <main className="agreement-page__main">

                <div className="lnd-container">

                    {!agreement ? (
                        <div className="agreement-page__loading">
                            {appStore.tr.loading || "Loading..."}
                        </div>
                    ) : (
                        <div className="agreement-card">

                            <h1 className="agreement-title">
                                {agreement.title}
                            </h1>

                            <div className="agreement-text">
                                <HtmlDiv content={agreement.text}/>
                            </div>


                            <div className="agreement-sign">

                                <div className="agreement-field">
                                    <label>
                                        {appStore.tr.full_name || "ФИО"}
                                    </label>

                                    <InputText
                                        value={fullName}
                                        onChange={(e) =>
                                            setFullName(e.target.value)
                                        }
                                        className="w-full"
                                    />
                                </div>


                                <div className="agreement-accept-row">

                                    <Checkbox
                                        inputId="agreementAccepted"
                                        checked={accepted}
                                        onChange={(e) =>
                                            setAccepted(e.checked)
                                        }
                                    />

                                    <label
                                        htmlFor="agreementAccepted"
                                        className="agreement-accept-label"
                                    >
                                        {appStore.tr.agreement_accept_confirmation}
                                    </label>

                                </div>


                                <button
                                    type="button"
                                    className="lnd-btn lnd-btn--primary agreement-submit"
                                    disabled={
                                        !accepted ||
                                        !fullName.trim()
                                    }
                                    onClick={acceptAgreement}
                                >
                                    {appStore.tr.accept_agreement}
                                </button>

                            </div>

                        </div>
                    )}

                </div>

            </main>

        </div>
    );
}